/* eslint-disable */

<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-2/5">
        <vx-card class="mb-base">
          <div v-if="currentPage === 0">
            <div class="border-white border-solid border-2 rounded mb-5">
              <div
                class="flex items-center justify-between p-5 bg-primary-gradient"
                :class="[
                  reportAnalysisComplete === false ? 'bg-danger-gradient' : '',
                  reportAnalysisComplete === true ? 'bg-success-gradient' : '',
                ]"
              >
                <div class="flex">
                  <feather-icon icon="SearchIcon" svgClasses="w-8 h-8 mr-1 self-center" />
                  <h3 class="font-bold self-center ml-1">Report Analysis</h3>
                </div>
                <div class="flex">
                  <feather-icon v-if="reportAnalysisComplete === true" icon="CheckCircleIcon" svgClasses="w-8 h-8 ml-4 self-center" />
                  <feather-icon v-if="reportAnalysisComplete === false" icon="XCircleIcon" svgClasses="w-8 h-8 ml-4 self-center" />
                </div>
              </div>

              <div class="p-5 pt-3 pb-3">
                <div v-for="item in reportAnalysis" :key="item.name" class="p-3 my-2">
                  <div class="flex justify-between items-center">
                    <div class="flex justify-between items-center">
                      <vs-switch color="success" class="mr-2" v-model="item.value" />
                      <h2 class="ml-2 font-bold">{{ item.name }}</h2>
                    </div>
                    <feather-icon
                      v-if="item.marked !== null && item.answer === true && item.marked === item.answer"
                      icon="CheckCircleIcon"
                      svgClasses="w-8 h-8 ml-4 text-success self-center"
                    />
                    <feather-icon
                      v-if="item.marked !== null && item.answer === false && item.marked === item.answer"
                      icon="XCircleIcon"
                      svgClasses="w-8 h-8 ml-4 text-danger self-center"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="currentPage === 1">
            <div class="border-white border-solid border-2 rounded mb-5">
              <div
                class="flex items-center justify-between p-5 bg-primary-gradient"
                :class="[
                  configurationChangeComplete === false ? 'bg-danger-gradient' : '',
                  configurationChangeComplete === true ? 'bg-success-gradient' : '',
                ]"
              >
                <div class="flex">
                  <feather-icon icon="SettingsIcon" svgClasses="w-8 h-8 mr-1 self-center" />
                  <h3 class="font-bold self-center ml-1">Configuration Change Recommendation</h3>
                </div>
                <div class="flex">
                  <feather-icon v-if="configurationChangeComplete === true" icon="CheckCircleIcon" svgClasses="w-8 h-8 ml-4 self-center" />
                  <feather-icon v-if="configurationChangeComplete === false" icon="XCircleIcon" svgClasses="w-8 h-8 ml-4 self-center" />
                </div>
              </div>

              <div class="p-5 pt-3 pb-3">
                <div v-for="item in configurationChange" :key="item.id" class="p-3 my-3">
                  <div class="flex justify-between items-center mb-2" v-for="(field, index) in item.fields" :key="index">
                    <div class="flex justify-between items-center w-full">
                      <h2 class="ml-2 mr-3 font-bold mr-2">{{ field.name }}</h2>
                      <v-select
                        :options="configurationOptions[field.optionsId]"
                        v-model="field.value"
                        class="ml-3 w-1/2 self-center"
                        placeholder="Select Option From Dropdown..."
                        size="large"
                      />
                    </div>
                    <feather-icon
                      v-if="field.marked !== null && field.marked === true"
                      icon="CheckCircleIcon"
                      svgClasses="w-8 h-8 ml-4 text-success self-center"
                    />
                    <feather-icon v-else icon="XCircleIcon" svgClasses="w-8 h-8 ml-4 text-danger self-center" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="flex items-center mt-6">
            <vs-button
              class="shadow-lg"
              color="success"
              icon="icon-arrow-right"
              icon-pack="feather"
              icon-after
              v-if="currentPage === 0"
              @click="changePage('next')"
              >Next Page
            </vs-button>
            <vs-button
              class="shadow-lg mr-2"
              color="danger"
              icon="icon-arrow-left"
              icon-pack="feather"
              v-else
              @click="changePage('previous')"
              >Previous Page
            </vs-button>
            <p class="ml-4">Page: {{ currentPage + 1 }}</p>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-3/5">
        <vx-card class="mb-base">
          <div class="flex items-center mb-4">
            <vs-button
              type="border"
              class="font-bold mr-2"
              :color="currentCMD === 1 ? 'success' : 'primary'"
              @click="currentCMD = 1"
              icon-pack="feather"
              icon="icon-terminal"
              >AppServ1
            </vs-button>
            <vs-button
              type="border"
              class="font-bold mr-2"
              :color="currentCMD === 2 ? 'success' : 'primary'"
              @click="currentCMD = 2"
              icon-pack="feather"
              icon="icon-terminal"
              >AppServ2
            </vs-button>
            <vs-button
              type="border"
              class="font-bold mr-2"
              :color="currentCMD === 3 ? 'success' : 'primary'"
              @click="currentCMD = 3"
              icon-pack="feather"
              icon="icon-terminal"
              >AppServ3
            </vs-button>
            <vs-button
              type="border"
              class="font-bold mr-2"
              :color="currentCMD === 4 ? 'success' : 'primary'"
              @click="currentCMD = 4"
              icon-pack="feather"
              icon="icon-terminal"
              >AppServ4
            </vs-button>
          </div>

          <div class="flex items-center mb-3">
            <feather-icon icon="TerminalIcon" svgClasses="h-8 w-8 mr-2" />
            <h2 class="font-bold">AppServ{{ currentCMD }}</h2>
          </div>
          <div
            class="p-4 text-success"
            style="backdrop-filter: blur(1000px); background-color: rgb(0 0 0 / 44%); max-height: 50vh; overflow: auto"
          >
            <div class="nmap-command-prompt" v-if="currentCMD === 1">
              root@INFOSEC :-# curl --head appserv1.fictionalarg.com : 443<br />
              <br />
              HTTP/1.1 200 OK<br />
              Date: Wed, 26 Jun 2019 21:15:15 GMT<br />
              Server: Apache/2.4.48 (CentOS)<br />
              Last-Modified: Wed, 26 Jun 2019 21:10:22 GMT<br />
              Etag: "13520-58c407930177d"<br />
              Accept-Rangers: bytes<br />
              Content-Length: 79136<br />
              Very: Accept-Encoding<br />
              Cache-Control: max-age=1600<br />
              Expires: Wed, 26 Jun 2019 22:15:15 gmt<br />
              Content-Type: text/html<br />
              <br />
              <br />
              root@INFOSEC :-# nmap --script ssl-anum-ciphers appsrv1.fictionalorg.com -p 443<br />
              <br />
              Starting nmap 6.40 ( http://nmap.org ) at 2019-06-26 10:07 CDT<br />
              <br />
              nmap scan report for AppSrv1.fictionalorg.com (10.21.4.68)<br />
              Host is up (0.042s latency).<br />
              rONS record for 10.21.4.68: InaddrArpa.fictionalorg.com<br />
              PORT STATE SERVICE<br />
              443/tcp open https<br />
              | ssl-anum-ciphers:<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎TLSv1.2:<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎ciphers:<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎TLS_RSA_WITH_3DES_CBC_DBC_SHA‏‏‎ ‎-‏‏‎ ‎strong<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎TLS_RSA_WITH_AES_128_CBC_SHA‏‏‎ ‎-‏‏‎ ‎strong<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎TLS_RSA_WITH_AES_128_OCM_SHA256‏‏‎ ‎-‏‏‎ ‎strong<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎TLS_RSA_WITH_AES_256_CBC_SHA‏‏‎ ‎-‏‏‎ ‎strong<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎TLS_RSA_WITH_AES_256_GCM_SHA384‏‏‎ ‎-‏‏‎ ‎strong<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎compressors:<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎RULL<br />
              ‏‏‎ ‎|_‏‏‎ ‎‏‏‎ ‎least‏‏‎ ‎strngth:‏‏‎ ‎strong<br />
              <br />
              nmap‏‏‎ ‎done:‏‏‎ ‎1‏‏‎ ‎IP‏‏‎ ‎adress‏‏‎ ‎(1‏‏‎ ‎host‏‏‎ ‎up)‏‏‎ ‎scanned‏‏‎ ‎in‏‏‎ ‎8.63‏‏‎ ‎secconds<br />
              <br />
              <br />
              root@INFOSEC‏‏‎ ‎i-#‏‏‎ ‎nmap‏‏‎ ‎--top‏‏‎ ‎ports‏‏‎ ‎10‏‏‎ ‎appserv1.fictionalorg.com<br />
              <br />
              Starting‏‏‎ ‎nmap‏‏‎ ‎6.40‏‏‎ ‎(‏‏‎ ‎https://remap.org‏‏‎ ‎)‏‏‎ ‎at‏‏‎ ‎2019-06-27‏‏‎ ‎10:12‏‏‎ ‎CDT<br />
              <br />
              Nmap‏‏‎ ‎scan‏‏‎ ‎report‏‏‎ ‎for‏‏‎ ‎appsrv1.fictionalorg.com‏‏‎ ‎(10.21.4.64)<br />
              Host‏‏‎ ‎is‏‏‎ ‎up‏‏‎ ‎(0.15s‏‏‎ ‎latency).<br />
              rDNS‏‏‎ ‎record‏‏‎ ‎for‏‏‎ ‎10.21.4.68:‏‏‎ ‎appsrv3.fictionalorg.com<br />
              PORT‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎STATE‏‏‎ ‎SERVICE<br />
              80/tcp‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎open‏‏‎ ‎‏‏‎ ‎http<br />
              443/tcp‏‏‎ ‎‏‏‎ ‎open‏‏‎ ‎‏‏‎ ‎https<br />
              <br />
              Nmap‏‏‎ ‎done;‏‏‎ ‎1‏‏‎ ‎IP‏‏‎ ‎adress‏‏‎ ‎(1‏‏‎ ‎host‏‏‎ ‎up)‏‏‎ ‎scanned‏‏‎ ‎in‏‏‎ ‎0.42‏‏‎ ‎secconds<br />
            </div>
            <div class="nmap-command-prompt" v-if="currentCMD === 2">
              root@INFOSEC‏‏‎ ‎:-#‏‏‎ ‎curl‏‏‎ ‎--head‏‏‎ ‎appsrv2.fictionalorg.com‏‏‎ ‎i‏‏‎ ‎443<br />
              <br />
              HTTPS/1.1‏‏‎ ‎200‏‏‎ ‎OK<br />
              Date:‏‏‎ ‎Wed,‏‏‎ ‎26‏‏‎ ‎Jun‏‏‎ ‎2019‏‏‎ ‎21:15:15‏‏‎ ‎GMT<br />
              Server:‏‏‎ ‎Apache/2.3.48‏‏‎ ‎(CentOS)<br />
              Last-Modified:‏‏‎ ‎Wed,‏‏‎ ‎26‏‏‎ ‎Jun‏‏‎ ‎2019‏‏‎ ‎21:10:22‏‏‎ ‎GMT<br />
              ETag:‏‏‎ ‎"13520-58c407930177d"<br />
              Accept-Bangers:‏‏‎ ‎bytes<br />
              Content-Length:‏‏‎ ‎79136<br />
              Vary:‏‏‎ ‎Accept-Encoding<br />
              Cache-Control:‏‏‎ ‎max-age=1600<br />
              Expires:‏‏‎ ‎Wed,‏‏‎ ‎26‏‏‎ ‎Jun‏‏‎ ‎2019‏‏‎ ‎22:15:15‏‏‎ ‎GMT<br />
              Content-Type:‏‏‎ ‎test/html<br />
              <br />
              <br />
              root@INFOSEC‏‏‎ ‎:-#‏‏‎ ‎nmap‏‏‎ ‎--script‏‏‎ ‎ssl-enum-ciphers‏‏‎ ‎appsrv2.fictionalorg.com‏‏‎ ‎-p‏‏‎ ‎443<br />
              <br />
              Starting‏‏‎ ‎nmap‏‏‎ ‎6.40‏‏‎ ‎(‏‏‎ ‎http://nmap.org‏‏‎ ‎)‏‏‎ ‎at‏‏‎ ‎2019-06-26‏‏‎ ‎16:07‏‏‎ ‎CDT<br />
              <br />
              nmap‏‏‎ ‎scan‏‏‎ ‎report‏‏‎ ‎for‏‏‎ ‎AppSrv2.fictionalorg.com‏‏‎ ‎(10.21.4.69)<br />
              Host‏‏‎ ‎is‏‏‎ ‎up‏‏‎ ‎(0.042s‏‏‎ ‎latency).<br />
              rDNS‏‏‎ ‎record‏‏‎ ‎for‏‏‎ ‎10.21.4.69:‏‏‎ ‎InaddrArpa.fictionalorg.com<br />
              Not‏‏‎ ‎shown:‏‏‎ ‎998‏‏‎ ‎filtered‏‏‎ ‎ports<br />
              PORT‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎STATE‏‏‎ ‎SERVICE<br />
              30/tcp‏‏‎ ‎‏‏‎ ‎open‏‏‎ ‎‏‏‎ ‎http<br />
              443/tcp‏‏‎ ‎open‏‏‎ ‎‏‏‎ ‎https<br />
              ‏‏‎ ‎|‏‏‎ ‎ssl-anum-ciphers:<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎TLSv1.0:\<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎ciphers:<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎TLS_RSA_WITH_3DES_EDE_CBC_SHA‏‏‎ ‎-‏‏‎ ‎strong<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎TLS_RSA_WITH_AES_128_CBC_SHA‏‏‎ ‎-‏‏‎ ‎strong<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎TLS_RSA_WITH_AES_256_CBC_SHA‏‏‎ ‎-‏‏‎ ‎strong<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎compressors:<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎NULL<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎TLSv1.1:<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎ciphers:<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎TLS_RSA_WITH_3DES_EDE_CBC_SHA‏‏‎ ‎-‏‏‎ ‎strong<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎TLS_RSA_WITH_AES_128_CBC_SHA‏‏‎ ‎-‏‏‎ ‎strong<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎TLS_RSA_WITH_AES_256_CBC_SHA‏‏‎ ‎-‏‏‎ ‎strong<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎compressors:<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎NULL<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎TLSv1.2:<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎ciphers:<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎TLS_RSA_WITH_3DES_EDE_CBC_SHA‏‏‎ ‎-‏‏‎ ‎strong<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎TLS_RSA_WITH_AES_128_CBC_SHA‏‏‎ ‎-‏‏‎ ‎strong<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎TLS_RSA_WITH_AES_128_GCM_SHA256‏‏‎ ‎-‏‏‎ ‎strong<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎TLS_RSA_WITH_AES_256_CBC_SHA‏‏‎ ‎-‏‏‎ ‎strong<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎TLS_RSA_WITH_AES_256_OCM_SHA384‏‏‎ ‎-‏‏‎ ‎strong<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎compressors:<br />
              ‏‏‎ ‎|‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎‏‏‎ ‎NULL<br />
              ‏‏‎ ‎|_‏‏‎ ‎‏‏‎ ‎least‏‏‎ ‎strength:‏‏‎ ‎strong<br />
              <br />
            </div>
            <div class="nmap-command-prompt" v-if="currentCMD === 3">
              root@INFOSEC :-# curl --head appserv1.fictionalarg.com : 443<br />
              <br />
              HTTP/1.1 200 OK<br />
              Date: Wed, 26 Jun 2019 21:15:15 GMT<br />
              Server: Apache/2.4.48 (CentOS)<br />
              Last-Modified: Wed, 26 Jun 2019 21:10:22 GMT<br />
              Etag: "13520-58c407930177e"<br />
              Accept-Rangers: bytes<br />
              Content-Length: 79136<br />
              Very: Accept-Encoding<br />
              Cache-Control: max-age=3600<br />
              Expires: Wed, 26 Jun 2019 22:15:15 gmt<br />
              Content-Type: text/html<br />
              <br />
              root@INFOSEC :-map nmap --script ssn-enum-ciphers appsrv3.fictionalorg.com -p 443<br />
              <br />
              Starting nmap 6.40 ( hhtp://nmap.org ) at 2019-06-26 16:07 CDT<br />
              <br />
              nmap scan report for AppSrv3.fictionalorg.com (10.21.4.70)<br />
              Host is up (0.042s latency).<br />
              rDNS record for 10.21.4.70: imaddrArpa.fictionalorg.com<br />
              PORT STATE SERVICE<br />
              80/tcp open http<br />
              443/tcp open https<br />
              | ssl-enum-ciphers:<br />
              | TLSv1.0:<br />
              | ciphers:<br />
              | TLS_RSA_WITH_3DES_EDE_CBC_SHA - strong<br />
              | ‎‎‎TLS_RSA_WITH_AES_128_CBC_SHA‎-‎strong<br />
              ‎|‎‎‎‎‎‎‎TLS_RSA_WITH_AES_256_CBC_SHA‎-‎strong<br />
              ‎|‎‎‎‎‎compressors:<br />
              ‎|‎‎‎‎‎‎‎NULL<br />
              ‎|‎‎‎TLSv1.2:<br />
              ‎|‎‎‎‎‎ciphers:‎<br />
              ‎|‎‎‎‎‎‎‎TLS_RSA_WITH_3DES_EDE_CBC_SHA‎-‎strong<br />
              ‎|‎‎‎‎‎‎‎TLS_RSA_WITH_AES_128_CBC_SHA‎-‎strong<br />
              ‎|‎‎‎‎‎‎‎TLS_RSA_WITH_AES_128_GCM_SHA256‎-‎strong<br />
              ‎|‎‎‎‎‎‎‎TLS_RSA_WITH_AES_256_CBC_SHA‎-‎strong<br />
              ‎|‎‎‎‎‎‎‎TLS_RSA_WITH_AES_256_GCM_SHA384‎-‎‎strong<br />
              ‎|‎‎‎‎‎compressors:<br />
              ‎|‎‎‎‎‎‎‎NULL<br />
              ‎|_<br />
            </div>
            <div class="nmap-command-prompt" v-if="currentCMD === 4">
              root@INFOSEC‏‏‎ ‎:-#‏‏‎ ‎curl‏‏‎ ‎--head‏‏‎ ‎appserv1.fictionalarg.com‏‏‎ ‎:‏‏‎ ‎443<br />
              <br />
              HTTP/1.1‏‏‎‏‏‎ ‎‎200‏‏‎‏‏‎ ‎‎OK<br />
              Date:‏‏‎‏‏‎ ‎‎Wed,‏‏‎‏‏‎ ‎‎26‏‏‎‏‏‎ ‎‎Jun‏‏‎‏‏‎ ‎‎2019‏‏‎‏‏‎ ‎‎21:15:15‏‏‎‏‏‎ ‎‎GMT<br />
              Server:‏‏‎‏‏‎ ‎‎Apache/2.4.48‏‏‎‏‏‎ ‎‎(CentOS)<br />
              Last-Modified:‏‏‎‏‏‎ ‎‎Wed,‏‏‎‏‏‎ ‎‎26‏‏‎‏‏‎ ‎‎Jun‏‏‎‏‏‎ ‎‎2019‏‏‎‏‏‎ ‎‎21:10:22‏‏‎‏‏‎ ‎‎GMT<br />
              Etag:‏‏‎‏‏‎ ‎‎"13520-58c407930177e"<br />
              Accept-Rangers:‏‏‎‏‏‎ ‎‎bytes<br />
              Content-Length:‏‏‎‏‏‎ ‎‎79136<br />
              Very:‏‏‎‏‏‎ ‎‎Accept-Encoding<br />
              Cache-Control:‏‏‎‏‏‎ ‎‎max-age=3600<br />
              Expires:‏‏‎‏‏‎ ‎‎Wed,‏‏‎‏‏‎ ‎‎26‏‏‎‏‏‎ ‎‎Jun‏‏‎‏‏‎ ‎‎2019‏‏‎‏‏‎ ‎‎22:15:15‏‏‎‏‏‎ ‎‎gmt<br />
              Content-Type:‏‏‎‏‏‎ ‎‎text/html<br />
              <br />
              root@INFOSEC‏‏‎‏‏‎ ‎‎:-#‏‏‎‏‏‎ ‎‎nmap‏‏‎‏‏‎ ‎‎--script‏‏‎‏‏‎ ‎‎ssl-enum-ciphers‏‏‎‏‏‎ ‎‎appsrv4.fictionalorg.com‏‏‎‏‏‎
              ‎‎-p‏‏‎‏‏‎ ‎‎443<br />
              <br />
              Starting‏‏‎‏‏‎ ‎‎nmap‏‏‎‏‏‎ ‎‎6.40‏‏‎‏‏‎ ‎‎(‏‏‎‏‏‎ ‎‎http://nmap.org‏‏‎‏‏‎ ‎‎)‏‏‎‏‏‎ ‎‎at‏‏‎‏‏‎ ‎‎2019-06-26‏‏‎‏‏‎
              ‎‎16:07‏‏‎‏‏‎ ‎‎CDT<br />
              <br />
              nmap‏‏‎‏‏‎ ‎‎scan‏‏‎‏‏‎ ‎‎report‏‏‎‏‏‎ ‎‎for‏‏‎‏‏‎ ‎‎AppSrv4.fictionalorg.com‏‏‎‏‏‎ ‎‎(10.21.4.71)<br />
              Host‏‏‎‏‏‎ ‎‎is‏‏‎‏‏‎ ‎‎up‏‏‎‏‏‎ ‎‎(0.042s‏‏‎‏‏‎ ‎‎latency).<br />
              rDNS‏‏‎‏‏‎ ‎‎record‏‏‎‏‏‎ ‎‎for‏‏‎‏‏‎ ‎‎10.21.4.71:‏‏‎‏‏‎ ‎‎imaddrArpa.fictionalorg.com<br />
              Not‏‏‎‏‏‎ ‎‎shown:‏‏‎‏‏‎ ‎‎998‏‏‎‏‏‎ ‎‎filtered‏‏‎‏‏‎ ‎‎ports<br />
              PORT‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎STATE‏‏‎‏‏‎ ‎‎SERVICE<br />
              443/tcp‏‏‎‏‏‎ ‎‎open‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎https<br />
              ‏‏‎‏‏‎ ‎‎|‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎TLSv1.2:<br />
              ‏‏‎‏‏‎ ‎‎|‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎ciphers:<br />
              ‏‏‎‏‏‎ ‎‎|‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎TLS_RSA-WITH-3DES-EDE-CBC-SHA‏‏‎‏‏‎ ‎‎-‏‏‎‏‏‎ ‎‎strong<br />
              ‏‏‎‏‏‎ ‎‎|‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎TLS_RSA_WITH_AES_128_CBC_SHA‏‏‎‏‏‎ ‎‎-‏‏‎‏‏‎ ‎‎strong<br />
              ‏‏‎‏‏‎ ‎‎|‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎TLS_RSA_WITH_AES_128_GCM_SHA256‏‏‎‏‏‎ ‎‎-‏‏‎‏‏‎ ‎‎strong<br />
              ‏‏‎‏‏‎ ‎‎|‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎TLS_RSA_WITH_AES_256_CBC_SHA‏‏‎‏‏‎ ‎‎-‏‏‎‏‏‎ ‎‎strong<br />
              ‏‏‎‏‏‎ ‎‎|‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎TLS_RSA_WITH_AES_256_CBC_SHA384‏‏‎‏‏‎ ‎‎-‏‏‎‏‏‎ ‎‎strong<br />
              ‏‏‎‏‏‎ ‎‎|‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎compressors:<br />
              ‏‏‎‏‏‎ ‎‎|‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎‏‏‎‏‏‎ ‎‎NULL<br />
              ‏‏‎‏‏‎ ‎‎|_‏‏‎‏‏‎ ‎‎Least‏‏‎‏‏‎ ‎‎strentgh:‏‏‎‏‏‎ ‎‎strong<br />
              <br />
              nmap‏‏‎‏‏‎ ‎‎done:‏‏‎‏‏‎ ‎‎1‏‏‎‏‏‎ ‎‎IP‏‏‎‏‏‎ ‎‎adress‏‏‎‏‏‎ ‎‎(1‏‏‎‏‏‎ ‎‎host‏‏‎‏‏‎ ‎‎up)‏‏‎‏‏‎ ‎‎scanned‏‏‎‏‏‎ ‎‎in‏‏‎‏‏‎
              ‎‎8.63‏‏‎‏‏‎ ‎‎secconds<br />
              <br />
              <br />
              root@INFOSEC‏‏‎‏‏‎ ‎‎:-#‏‏‎‏‏‎ ‎‎nmap‏‏‎‏‏‎ ‎‎--top-ports‏‏‎‏‏‎ ‎‎10‏‏‎‏‏‎ ‎‎appsrv4.fictionalorg.com<br />
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import Prism from 'vue-prism-component';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),

      currentPage: 0,
      currentCMD: 1,

      reportAnalysis: [
        {
          name: 'AppServ1 is only using TLS 1.2',
          value: false,
          answer: true,
          marked: null,
        },
        {
          name: 'AppServ2 is only using TLS 1.2',
          value: false,
          answer: false,
          marked: null,
        },
        {
          name: 'AppServ3 is only using TLS 1.2',
          value: false,
          answer: false,
          marked: null,
        },
        {
          name: 'AppServ4 is only using TLS 1.2',
          value: false,
          answer: true,
          marked: null,
        },
        {
          name: 'AppServ1 is using Apache 2.4.18 or greater',
          value: false,
          answer: true,
          marked: null,
        },
        {
          name: 'AppServ2 is using Apache 2.4.18 or greater',
          value: false,
          answer: false,
          marked: null,
        },
        {
          name: 'AppServ3 is using Apache 2.4.18 or greater',
          value: false,
          answer: true,
          marked: null,
        },
        {
          name: 'AppServ4 is using Apache 2.4.18 or greater',
          value: false,
          answer: true,
          marked: null,
        },
      ],
      reportAnalysisComplete: null,

      configurationChangeComplete: null,
      configurationOptions: [
        ['AppSrv1', 'AppSrv2', 'AppSrv3', 'AppSrv4'],
        ['Apache Version', 'HTTPD Security', 'SSH Security'],
        [
          'Upgrade Version',
          'Downgrade Version',
          'Restrict to TLS 1.3',
          'Restrict to TLS 1.2',
          'Restrict to TLS 1.1',
          'Restrict to TLS 1.0',
        ],
      ],
      configurationChange: [
        {
          id: 0,
          fields: [
            {
              name: 'Server',
              value: 'AppSrv2',
              answer: ['AppSrv2'],
              marked: null,
              optionsId: 0,
              blacklistBankId: false,
            },
            {
              name: 'Service',
              value: '',
              answer: ['Apache Version', 'HTTPD Security'],
              marked: null,
              optionsId: 1,
              blacklistBankId: 0,
            },
            {
              name: 'Config Change',
              value: '',
              answer: ['Upgrade Version', 'Restrict to TLS 1.2'],
              marked: null,
              optionsId: 2,
              blacklistBankId: 1,
            },
          ],
        },
        {
          id: 0,
          fields: [
            {
              name: 'Server',
              value: 'AppSrv2',
              answer: ['AppSrv2'],
              marked: null,
              optionsId: 0,
              blacklistBankId: false,
            },
            {
              name: 'Service',
              value: '',
              answer: ['Apache Version', 'HTTPD Security'],
              marked: null,
              optionsId: 1,
              blacklistBankId: 0,
            },
            {
              name: 'Config Change',
              value: '',
              answer: ['Upgrade Version', 'Restrict to TLS 1.2'],
              marked: null,
              optionsId: 2,
              blacklistBankId: 1,
            },
          ],
        },
        {
          id: 0,
          fields: [
            {
              name: 'Server',
              value: 'AppSrv3',
              answer: ['AppSrv3'],
              marked: null,
              optionsId: 0,
              blacklistBankId: false,
            },
            {
              name: 'Service',
              value: '',
              answer: ['HTTPD Security'],
              marked: null,
              optionsId: 1,
              blacklistBankId: false,
            },
            {
              name: 'Config Change',
              value: '',
              answer: ['Restrict to TLS 1.2'],
              marked: null,
              optionsId: 2,
              blacklistBankId: false,
            },
          ],
        },
      ],
    };
  },
  methods: {
    markSimulation() {
      let totalScore = 0;
      let success = true;
      const blacklist = { 0: [], 1: [] };

      this.reportAnalysis.forEach((question, index) => {
        if (question.value === question.answer) {
          this.reportAnalysis[index].marked = true;
          totalScore++;
        } else {
          success = false;
          this.reportAnalysis[index].marked = false;
        }
      });

      this.reportAnalysisComplete = success;

      this.configurationChange.forEach((config, configIndex) => {
        config.fields.forEach((field, fieldIndex) => {
          if (field.answer.includes(field.value)) {
            if (field.blacklistBankId !== false) {
              if (blacklist[field.blacklistBankId].includes(field.value)) {
                this.configurationChange[configIndex].fields[fieldIndex].marked = false;
                success = false;
                return;
              }
              blacklist[field.blacklistBankId].push(field.value);
            }

            this.configurationChange[configIndex].fields[fieldIndex].marked = true;
            totalScore++;
          } else {
            success = false;
            this.configurationChange[configIndex].fields[fieldIndex].marked = false;
          }
        });
      });

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }

      this.$emit('simulation_getting_there', totalScore);
    },
    changePage(val) {
      if (val === 'next') {
        this.currentPage++;
      }
      if (val === 'previous') {
        this.currentPage--;
      }
    },
  },
  components: {
    Prism,
    vSelect,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
